import { Component, Input } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { LearningPlanStatus } from '../../models/LearningPlanDTO';

@Component({
  selector: 'app-learning-plan-status',
  imports: [MatChip, TranslocoDirective, MatTooltip, NgClass],
  templateUrl: './learning-plan-status.component.html',
})
export class LearningPlanStatusComponent {
  @Input() status: LearningPlanStatus;
  protected readonly lpStatus = LearningPlanStatus;

  get getBgColorClass() {
    switch (this.status) {
      case LearningPlanStatus.ACTIVE:
        return '!bg-blue-light';
      case LearningPlanStatus.SCHEDULED:
        return '!bg-orange-light';
      case LearningPlanStatus.ARCHIVED:
      default:
        return '!bg-grey-lightGrey';
    }
  }

  get getTextColorClass() {
    switch (this.status) {
      case LearningPlanStatus.ACTIVE:
        return '!text-blue-light';
      case LearningPlanStatus.SCHEDULED:
        return '!text-orange';
      case LearningPlanStatus.ARCHIVED:
      default:
        return '!text-grey';
    }
  }

  get isActive(): boolean {
    return this.status === LearningPlanStatus.ACTIVE;
  }
}
